import { realtimeClient } from "./realtime-client";
import { RealtimeEvents } from "./realtime-events";

export class RealtimeReceiveMessage {
    static async execute(sessionId: string, executeFn: (message: any) => void): Promise<void> {
        const client = realtimeClient(sessionId);
        await client.channels.get(sessionId).subscribe(RealtimeEvents.ACTION, (message) => {
            executeFn(message);
        });
    }
}